import { FC, useState } from 'react'

import { Modal } from 'components/modal'
import { Caption, Figure, Image, ImageContainer } from './styled'

type Props = {
  src: string
  caption: string
}

export const ClickableImage: FC<Props> = ({ caption, src, ...rest }) => {
  const [isOpen, setOpen] = useState(false)

  return (
    <>
      <Figure>
        <img
          {...rest}
          src={src}
          alt={caption}
          data-clickable
          onClick={() => setOpen(true)}
        />
        {!!caption && <figcaption>{caption}</figcaption>}
      </Figure>

      <Modal
        fullscreen
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        ModalBodyComponent={ImageContainer}
      >
        <Image src={src} alt={caption} />
        {!!caption && <Caption>{caption}</Caption>}
      </Modal>
    </>
  )
}
